import { useEffect } from 'react';

const ThirdPartyScripts = () => {
  useEffect(() => {
    let analyticsLoaded = false;

    const removeChatbase = () => {
      document
        .querySelectorAll(
          'script#a2AmkiY0sk69Jb2llHDfQ, script[src*="chatbase.co/embed.min.js"], iframe[src*="chatbase.co"]'
        )
        .forEach((node) => node.remove());

      try {
        delete window.chatbase;
      } catch (error) {
        window.chatbase = undefined;
      }
    };

    const loadAnalytics = () => {
      if (analyticsLoaded) return;
      analyticsLoaded = true;

      // Load Facebook Pixel
      const loadFacebookPixel = () => {
        if (window.fbq) return; // Already loaded
        
        const fbScript = document.createElement('script');
        fbScript.innerHTML = `
          !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return
            n = f.fbq = function () {
              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            }
            if (!f._fbq) f._fbq = n
            n.push = n
            n.loaded = !0
            n.version = '2.0'
            n.queue = []
            t = b.createElement(e)
            t.async = !0
            t.src = v
            s = b.getElementsByTagName(e)[0]
            s.parentNode.insertBefore(t, s)
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1393438748185615');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(fbScript);
      };

      // Load TikTok Pixel
      const loadTikTokPixel = () => {
        if (window.ttq) return; // Already loaded
        
        const ttScript = document.createElement('script');
        ttScript.innerHTML = `
          !(function (w, d, t) {
            w.TiktokAnalyticsObject = t
            var ttq = (w[t] = w[t] || []);
            (ttq.methods = [
              'page',
              'track',
              'identify',
              'instances',
              'debug',
              'on',
              'off',
              'once',
              'ready',
              'alias',
              'group',
              'enableCookie',
              'disableCookie',
              'holdConsent',
              'revokeConsent',
              'grantConsent',
            ]),
              (ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                  t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                }
              })
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            (ttq.instance = function (t) {
              for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
                ttq.setAndDefer(e, ttq.methods[n])
              return e
            }),
              (ttq.load = function (e, n) {
                var r = 'https://analytics.tiktok.com/i18n/pixel/events.js',
                  o = n && n.partner;
                (ttq._i = ttq._i || {}),
                  (ttq._i[e] = []),
                  (ttq._i[e]._u = r),
                  (ttq._t = ttq._t || {}),
                  (ttq._t[e] = +new Date()),
                  (ttq._o = ttq._o || {}),
                  (ttq._o[e] = n || {})
                n = document.createElement('script');
                (n.type = 'text/javascript'), (n.async = !0), (n.src = r + '?sdkid=' + e + '&lib=' + t)
                e = document.getElementsByTagName('script')[0]
                e.parentNode.insertBefore(n, e)
              })
            ttq.load('CV9DU03C77UCRE2PGR70')
            ttq.page()
          })(window, document, 'ttq');
        `;
        document.head.appendChild(ttScript);
      };

      // Load Google Tag Manager
      const loadGoogleTagManager = () => {
        if (window.dataLayer) return; // Already loaded
        
        const gtmScript = document.createElement('script');
        gtmScript.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-T77XG2B4');
        `;
        document.head.appendChild(gtmScript);
      };

      loadGoogleTagManager();
      loadFacebookPixel();
      loadTikTokPixel();
    };

    removeChatbase();

    // Load analytics after 5 seconds or on first user interaction
    const timer = setTimeout(loadAnalytics, 5000);
    
    // Also load on first interaction (whichever comes first)
    const interactionEvents = ['scroll', 'click', 'touchstart'];
    const handleInteraction = () => {
      clearTimeout(timer);
      loadAnalytics();
      // Remove all listeners after first interaction
      interactionEvents.forEach(event => {
        window.removeEventListener(event, handleInteraction);
      });
    };
    
    interactionEvents.forEach(event => {
      window.addEventListener(event, handleInteraction, { once: true, passive: true });
    });

    return () => {
      clearTimeout(timer);
      interactionEvents.forEach(event => {
        window.removeEventListener(event, handleInteraction);
      });
      removeChatbase();
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ThirdPartyScripts;
